import React from 'react';

interface Props {
    countryCode: string;
    phoneNumber?: string;
}

export const getFormattedPhoneNumber = (countryCode: string, phoneNumber?: string) => {
    if (!phoneNumber) return "";

    let areaCode = "";
    let restOfPhoneNumber = phoneNumber;

    if (phoneNumber.length === 11) {
        areaCode = phoneNumber.slice(0, 2);
        restOfPhoneNumber = phoneNumber.slice(2);
    }

    const withSpaceEveryThreeDigits = restOfPhoneNumber.match(/.{1,3}/g)?.join(' ') || "";
    const shouldCutOffAreaCode = countryCode === "PL";

    if (areaCode) {
        if (shouldCutOffAreaCode) {
            return withSpaceEveryThreeDigits
        }

        return `+${areaCode} ${withSpaceEveryThreeDigits}`;
    }

    return withSpaceEveryThreeDigits
}

export const FormattedPhoneNumber = ({phoneNumber, countryCode}: Props) => {
    if (!phoneNumber) return <></>;

    return (<>{getFormattedPhoneNumber(countryCode, phoneNumber)}</>);
}